import { FC } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { Technician } from 'src/interfaces/new-technician/technician';
import { ProfileStatus } from 'src/enums/common';
import { REPAIR_SERVICE_ID } from 'src/constants/repairRequest-constants';

interface SubmitProfileCardProps {
  technicianData: Technician;
  submitProfile: () => Promise<boolean>;
}

export const SubmitProfileCard: FC<SubmitProfileCardProps> = (props) => {
  const { technicianData, submitProfile } = props;
  const navigate = useNavigate();

  const onSubmit = async () => {
    const submitResult = await submitProfile();
    if (submitResult) {
      navigate('/dashboard/technicians/main/pending');
    }
  };

  return (
    <>
      {(technicianData.status === ProfileStatus.RESUBMIT
      || technicianData.status === ProfileStatus.INCOMPLETE)
      && (
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        sx={{
          my: 3
        }}
      >
        <Grid
          item
          display="contents"
        >
          <Button
            sx={{
              mr: 2
            }}
            color="primary"
            onClick={() => {
              if (technicianData?.status === ProfileStatus.INCOMPLETE) {
                navigate('/dashboard/technicians/main/incomplete');
              } else {
                navigate('/dashboard/technicians/main/pending');
              }
            }}
            variant="outlined"
          >
            Cancel
          </Button>
        </Grid>
        <Grid
          item
          display="contents"
        >
          <Button
            sx={{
              mr: 2
            }}
            disabled={
              technicianData.brandsProducts.length < 1
              && technicianData.services.filter((item) => item.id === REPAIR_SERVICE_ID).length > 0
            }
            color="primary"
            onClick={onSubmit}
            variant="contained"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      )}
      {(technicianData.brandsProducts.length < 1
        && technicianData.services.filter((item) => item.id === REPAIR_SERVICE_ID).length > 0) && (
          <Card
            variant="outlined"
            sx={{
              mt: 1,
              borderColor: '#FFBDC2'
            }}
          >
            <CardContent
              sx={{
                backgroundColor: '#FFF0F1',
              }}
            >
              <Grid
                container
                spacing={1}
                direction="column"
              >
                { (technicianData.brandsProducts.length < 1
              && technicianData.services.filter((item) => item.id === REPAIR_SERVICE_ID).length > 0)
              && (
                <Grid
                  item
                >
                  <Typography
                    color="red"
                    variant="body2"
                  >
                    * Brand and Product are Missing
                  </Typography>
                </Grid>
              )}
              </Grid>
            </CardContent>
          </Card>
      )}
    </>
  );
};

SubmitProfileCard.propTypes = {
  // @ts-ignore
  technicianData: PropTypes.object,
  submitProfile: PropTypes.func,
};
